import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Constrants from "../constrants/constrant";
import { useToast } from "../context/ToastProvider";

function Wishlist() {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthAndFetchWishlist();
  }, []);

  const checkAuthAndFetchWishlist = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      addToast("Please login to view your wishlist", "error");
      navigate("/login");
      return;
    }

    fetchWishlist();
  };

  const fetchWishlist = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await Constrants.get("/profile/wishlist", {
        headers: { Authorization: `Bearer ${token}` }
      });

      setWishlist(res.data.wishlist || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching wishlist:", error);
      addToast("Failed to load wishlist", "error");
      setLoading(false);
    }
  };

  const handleRemoveFromWishlist = async (appId) => {
    try {
      const token = localStorage.getItem("token");
      await Constrants.post(
        `/apps/${appId}/wishlist/toggle`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      // Remove from local state
      setWishlist(wishlist.filter(item => item.app_id !== appId));
      addToast("Removed from wishlist", "success");
    } catch (error) {
      console.error("Error removing from wishlist:", error);
      addToast("Failed to remove from wishlist", "error");
    }
  };

  if (loading) {
    return (
      <div style={styles.loaderContainer}>
        <div style={styles.spinner}></div>
      </div>
    );
  }

  return (
    <main className="main-content">
      <section className="section">
        <div className="section-header">
          <h2 className="section-title">My Wishlist</h2>
        </div>

        {wishlist.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px 20px" }}>
            <svg
              width="120"
              height="120"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ccc"
              strokeWidth="1"
              style={{ margin: "0 auto 20px" }}
            >
              <path d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5 2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z" />
            </svg>
            <h3 style={{ color: "#666", marginBottom: "10px" }}>Your wishlist is empty</h3>
            <p style={{ color: "#999", marginBottom: "20px" }}>
              Browse apps and add them to your wishlist
            </p>
            <Link
              to="/"
              className="primary-btn"
            >
              Explore Apps
            </Link>
          </div>
        ) : (
          <div className="games-grid">
            {wishlist.map((item) => {
              const app = item.app;
              if (!app) return null;

              return (
                <div className="game-card" key={item.id} style={{ position: "relative" }}>
                  <Link
                    to={`/app/details/${app.slug}`}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      className="game-image"
                      style={{
                        background: "linear-gradient(45deg, #fa709a, #fee140)",
                        backgroundImage: `url(${app.feature_graphic_url ? app.feature_graphic_url : app.icon_url})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat"
                      }}
                    >
                      <div
                        className="game-icon"
                        style={{
                          backgroundImage: `url(${app.icon_url})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      ></div>
                    </div>
                    <div className="game-info">
                      <div className="game-title">{app.name}</div>
                      <div className="game-developer">{app.developer}</div>
                      <div className="game-rating">
                        <span className="stars">
                          {"★".repeat(Math.floor(app.rating || 0))}
                          {"☆".repeat(5 - Math.floor(app.rating || 0))}
                        </span>
                        <span className="rating-text">
                          {app.rating ? parseFloat(app.rating).toFixed(1) : "N/A"}
                        </span>
                      </div>
                    </div>
                  </Link>

                  {/* Remove button */}
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleRemoveFromWishlist(app.id);
                    }}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      background: "rgba(255, 255, 255, 0.9)",
                      border: "none",
                      borderRadius: "50%",
                      width: "36px",
                      height: "36px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                      transition: "all 0.3s"
                    }}
                    title="Remove from wishlist"
                    onMouseOver={(e) => e.currentTarget.style.background = "rgba(211, 47, 47, 0.9)"}
                    onMouseOut={(e) => e.currentTarget.style.background = "rgba(255, 255, 255, 0.9)"}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#d32f2f">
                      <path d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5 2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z" />
                    </svg>
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </main>
  );
}

const styles = {
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "6px solid #ddd",
    borderTop: "6px solid #3498db",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};

const styleSheet = document.styleSheets[0];
if (styleSheet) {
  try {
    styleSheet.insertRule(
      `@keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }`,
      styleSheet.cssRules.length
    );
  } catch (e) {
    // Animation already exists
  }
}

export default Wishlist;